module.exports = __webpack_public_path__ + "static/img/3.c618b6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/panorama/3.jpg
// module id = 88TB
// module chunks = 1